"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsFalse = exports.IsTrue = exports.Xor = exports.Not = exports.Or = exports.And = void 0;
var expression_1 = require("./expression");
var datatypes_1 = require("../datatypes/datatypes");
var And = /** @class */ (function (_super) {
    __extends(And, _super);
    function And(json) {
        return _super.call(this, json) || this;
    }
    And.prototype.exec = function (ctx) {
        return datatypes_1.ThreeValuedLogic.and.apply(datatypes_1.ThreeValuedLogic, this.execArgs(ctx));
    };
    return And;
}(expression_1.Expression));
exports.And = And;
var Or = /** @class */ (function (_super) {
    __extends(Or, _super);
    function Or(json) {
        return _super.call(this, json) || this;
    }
    Or.prototype.exec = function (ctx) {
        return datatypes_1.ThreeValuedLogic.or.apply(datatypes_1.ThreeValuedLogic, this.execArgs(ctx));
    };
    return Or;
}(expression_1.Expression));
exports.Or = Or;
var Not = /** @class */ (function (_super) {
    __extends(Not, _super);
    function Not(json) {
        return _super.call(this, json) || this;
    }
    Not.prototype.exec = function (ctx) {
        return datatypes_1.ThreeValuedLogic.not(this.execArgs(ctx));
    };
    return Not;
}(expression_1.Expression));
exports.Not = Not;
var Xor = /** @class */ (function (_super) {
    __extends(Xor, _super);
    function Xor(json) {
        return _super.call(this, json) || this;
    }
    Xor.prototype.exec = function (ctx) {
        return datatypes_1.ThreeValuedLogic.xor.apply(datatypes_1.ThreeValuedLogic, this.execArgs(ctx));
    };
    return Xor;
}(expression_1.Expression));
exports.Xor = Xor;
var IsTrue = /** @class */ (function (_super) {
    __extends(IsTrue, _super);
    function IsTrue(json) {
        return _super.call(this, json) || this;
    }
    IsTrue.prototype.exec = function (ctx) {
        return true === this.execArgs(ctx);
    };
    return IsTrue;
}(expression_1.Expression));
exports.IsTrue = IsTrue;
var IsFalse = /** @class */ (function (_super) {
    __extends(IsFalse, _super);
    function IsFalse(json) {
        return _super.call(this, json) || this;
    }
    IsFalse.prototype.exec = function (ctx) {
        return false === this.execArgs(ctx);
    };
    return IsFalse;
}(expression_1.Expression));
exports.IsFalse = IsFalse;
//# sourceMappingURL=logical.js.map